import MojitoPresentation from 'mojito/presentation';

import {SpriteMapStorage} from '#core/utils/spritemap-storage/index.js';
import {ensureHierarchy, mergeTo} from '#core/utils/config-utils.js';

import {AbstractVisualFeature} from '#core/application/modules/visual-feature.js';

import {SportsContent} from '../sports-content.js';

import {virtualsFactory} from './virtuals.factory';

import SCHEMA from './virtuals.schema.yaml';
import PALETTE_SCHEMA from './virtuals.palette-schema.yaml';

const NavigationPathBuilder = MojitoPresentation.Base.Navigation.NavigationPathBuilder;

class VirtualsFeature extends AbstractVisualFeature {
    get name() {
        return 'Virtuals';
    }

    get configSchema() {
        return SCHEMA;
    }

    get paletteSchema() {
        return PALETTE_SCHEMA;
    }

    get ready() {
        return this.config.enabled;
    }

    get intent() {
        return {
            type: MojitoPresentation.Base.Intent.Types.VIEW,
            data: NavigationPathBuilder.toVirtualSports(),
        };
    }

    getVisualConfig(PALETTE) {
        return virtualsFactory(PALETTE);
    }

    beforeMojitoConfigBuild(mojitoConfig) {
        const {sportIdToSpritesMapping} = SpriteMapStorage;
        const configurations = ensureHierarchy(mojitoConfig, 'services.configurations');
        const sportIconMap = {};
        const sportIdMap = GENBET_BASED ? this.config.sportIdMapGenbet : this.config.sportIdMapQuantum;

        for (const key in sportIdMap) {
            if (!sportIdMap.hasOwnProperty(key)) {
                continue;
            }
            sportIconMap[key] = sportIdToSpritesMapping[key] || sportIdToSpritesMapping[sportIdMap[key]];
        }

        mergeTo(configurations, {
            SportsMenuView: {
                showVirtuals: this.config.showInSportsMenu,
            },
            VirtualSportsMenuItem: {
                sportIcons: sportIconMap,
            },
            ...(GENBET_BASED
                ? {
                      VirtualEventsCoupon: {
                          streamingSportIdMap: sportIdMap,
                          streamView: {
                              iframeViewer: {
                                  urlConfig: this.config.wide,
                              },
                              compactIframeViewer: {
                                  urlConfig: this.config.compact,
                              },
                          },
                          inplayStreamView: {
                              iframeViewer: {
                                  urlConfig: this.config.wideInplay || {},
                              },
                              compactIframeViewer: {
                                  urlConfig: this.config.compactInplay || {},
                              },
                          },
                      },
                  }
                : {
                      VirtualEventsCoupon: {
                          streamingSportIdMap: sportIdMap,
                      },
                      VirtualStream: {
                          iframeViewer: {
                              urlConfig: this.config.wide,
                          },
                          compactIframeViewer: {
                              urlConfig: this.config.compact,
                          },
                      },
                  }),
        });
        return super.beforeMojitoConfigBuild(mojitoConfig);
    }
}

if (FEATURES.virtuals) {
    new VirtualsFeature(SportsContent);
}
